import { render, staticRenderFns } from "./CompanyTransactions.vue?vue&type=template&id=870d95ee"
import script from "./CompanyTransactions.vue?vue&type=script&lang=js"
export * from "./CompanyTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports